// Une version plus élaborée de Multi selects 

import React, { useEffect, useState } from 'react';
import SelectsContainerV2 from './SelectsContainerV2';

const SlideMultiSelectsV2 = ({ slide, setPoints, points, changeState, setRight }) => {

  const [userAnswers, setUserAnswers] = useState([]);

  const correction = JSON.parse(slide.round_correction);

  const changeUserAnswers = (index, value) => {
    // Créer une copie du tableau
    let newArray = [...userAnswers];

    // Modifier la deuxième valeur dans la copie
    newArray[parseInt(index)] = parseInt(value);

    // Mettre à jour l'état avec la nouvelle copie du tableau
    setUserAnswers(newArray);
  }

  const checkAnswers = () => {
    let ready = true;
    console.log(userAnswers)
    userAnswers.forEach((answer) => {
      if (answer < 0) {
        console.log("test")
        ready = false;
      }
    });

    return ready;
  }

  const handleValidate = () => {
    if (userAnswers.length >= JSON.parse(slide.round_correction).length && checkAnswers()) {

      if (JSON.stringify(correction) === JSON.stringify(userAnswers)) {
        setPoints(points + 20);
        console.log("bon");
        changeState();
      }
      else {
        setRight(false);
        changeState();
      }
    }
  }

  useEffect(() => {

    //let newArray = [...userAnswers];
    let newArray = [];
    for (let i = 0; i < JSON.parse(slide?.round_correction).length; i++) {

      // Exceptions par slides

      if(parseInt(slide?.num) === 2294 || parseInt(slide?.num) === 2312){
        if(i === 0 || i === 2 || i === 4){
          newArray[i] = 0;
        }
        else{
          newArray[i] = -1;
        }
      }
      else{
        newArray[i] = -1;
      }
    }
    setUserAnswers(newArray);

  }, [slide])


  return (
    <>
      <article className={"tplt-" + slide.template}>
        <div className="question" dangerouslySetInnerHTML={{ __html: slide.question }}>

        </div>

        <ul className={'selects-list ' + slide?.answers_display + "-display"}>
          {JSON.parse(slide?.round_labels).map((label, index) =>
           <SelectsContainerV2 key={index} label={label} answers={JSON.parse(slide?.round_answers)} changeUserAnswers={changeUserAnswers} selectIndex={index} values={JSON.parse(slide?.answers)} answersDisplay={slide?.answers_display} cardsDescs={slide?.round_cards_descs && slide?.round_cards_descs !== null && JSON.parse(slide?.round_cards_descs).length === JSON.parse(slide?.round_correction).length ? JSON.parse(slide?.round_cards_descs)[index] : null} />
          )
          }
        </ul>
      </article>
      <button onClick={handleValidate}>
        Valider
      </button>
    </>
  );
};

export default SlideMultiSelectsV2;